import { TextField } from '@eleveo/components-react';
import React from 'react';
import { Field } from 'react-final-form';
import { useTranslation } from 'react-i18next';

import { useIntegrations } from '../../../../app/IntegrationsProvider';
import { composeValidators } from '../../../../utils/validations/composeValidators';
import { isNotOnlyWhiteCharacters } from '../../../../utils/validations/isNotOnlyWhiteCharacters';
import { max10000Chars } from '../../../../utils/validations/max10000Chars';
import { handleMaxCharsError } from '../../../../utils/validations/maxChars';
import { required } from '../../../../utils/validations/required';

export type AzureConnectionStringProps = {
  field: string;
} & Pick<React.ComponentPropsWithoutRef<typeof TextField>, 'isRequired' | 'label' | 'testId'>;

export const AzureConnectionString: React.FC<AzureConnectionStringProps> = ({ field, isRequired, label, testId }) => {
  const { t } = useTranslation();
  const { isInReadOnlyMode } = useIntegrations();

  return (
    <Field
      name={field}
      key={`${field}-${isRequired}`}
      validate={isRequired ? composeValidators(required, isNotOnlyWhiteCharacters, max10000Chars) : max10000Chars}
    >
      {({ input, meta }) => (
        <TextField
          isRequired={isRequired}
          isReadOnly={isInReadOnlyMode}
          label={label}
          className="w-full"
          validationState={meta.invalid ? 'invalid' : 'valid'}
          errorMessage={handleMaxCharsError(meta.error, t, 10000)}
          {...input}
          testId={testId}
        />
      )}
    </Field>
  );
};
